// extracted by mini-css-extract-plugin
export default {"OurPatientsPageWrapper":"OurPatientsPage_OurPatientsPageWrapper__fI4NT"};